import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { NgbNav, NgbNavChangeEvent } from "@ng-bootstrap/ng-bootstrap";

@Injectable({
  providedIn: "root"
})
export class TabSetNavigationHelper {
  private previousAction: NgbNavChangeEvent;
  private tabset: NgbNav;


  constructor(private router: Router) {


  }

  public setTabset(tabset: NgbNav) {
    this.tabset = tabset;

    this.tabset.navChange.subscribe((tab: NgbNavChangeEvent) => {
      this.previousAction = tab;
    });
  }

  public resetTabset() {
    if (this.previousAction) {
      const resetId = this.previousAction.activeId;

      this.navigateTo(resetId);
      const element = document.getElementById(resetId) as HTMLLinkElement;

      if (element) {
        element.parentElement.classList.add("active");
      }
    }
  }

  public setActiveTabByUrl() {
    const opfRoute = this.router.url.match(/\((.*?)\)/);

    if (opfRoute) {
      const opf = opfRoute[1].split("/")[0];
      const tabs = Array.from<HTMLElement>(document.querySelectorAll("ul[ngbnav] > li > a.nav-link"));
      const currentActiveTab = tabs.find(x => x.getAttribute("href").includes(opf));
      if (currentActiveTab) {
        this.tabset.activeId = currentActiveTab.id;
      }
    }
  }

  public navigateTo(path: string) {
    this.tabset.select(path);
  }
}
